import validator from 'validator'
export default {
  install(Vue) {
    Vue.prototype.$validator = validator
  },
}
